import { render, staticRenderFns } from "./fastTasks.vue?vue&type=template&id=8b0e2d30&scoped=true&"
import script from "./fastTasks.vue?vue&type=script&lang=js&"
export * from "./fastTasks.vue?vue&type=script&lang=js&"
import style0 from "./fastTasks.vue?vue&type=style&index=0&id=8b0e2d30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0e2d30",
  null
  
)

export default component.exports